import { useEffect } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { useSettings } from '../settings/SettingsContext';
import type { ProgramView } from './types';
import { warmPrograms } from './warmSpeech';

export default function SpeechWarmer() {
  const { user } = useAuth();
  const { settings, loaded } = useSettings();

  useEffect(() => {
    if (!user || !loaded) return;
    let live = true;
    void (async () => {
      try {
        const learners = await api<{ id: string }[]>('/learners', { token: true });
        for (const l of learners) {
          if (!live) return;
          const programs = await api<ProgramView[]>(`/programs?learnerId=${encodeURIComponent(l.id)}`, { token: true });
          if (live) warmPrograms(programs, settings.ttsVoice, settings.ttsRate);
        }
      } catch {
        return;
      }
    })();
    return () => { live = false; };
  }, [user, loaded, settings.ttsVoice, settings.ttsRate]);

  return null;
}
